import { render, staticRenderFns } from "./CompaniesCreatePage.vue?vue&type=template&id=09ea970d&scoped=true"
import script from "./CompaniesCreatePage.vue?vue&type=script&lang=ts"
export * from "./CompaniesCreatePage.vue?vue&type=script&lang=ts"
import style0 from "./CompaniesCreatePage.vue?vue&type=style&index=0&id=09ea970d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09ea970d",
  null
  
)

export default component.exports